import axios from 'axios'

const API_BASE = process.env.VUE_APP_API_URL || '/api'

const client = axios.create({
  baseURL: API_BASE,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json'
  }
})

client.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error)
)

export const scheduledTaskRunReadonlyApi = {
  list: (params = {}) => client.get('/scheduled-task-runs-readonly/', { params }),

  detail: (runId, locator = {}) => (
    client.get(`/scheduled-task-runs-readonly/${encodeURIComponent(runId)}`, {
      params: {
        task_id: locator.task_id || undefined,
        task_type: locator.task_type || undefined,
        batch_log_id: locator.batch_log_id || locator.log_id || undefined
      }
    })
  )
}

export default scheduledTaskRunReadonlyApi
